export default class Constants {
   constructor() {
      this.STOR_UPD_PASSWORD = "update-password";
      this.STOR_UPD_PROFILE = "update-profile";
      this.STOR_NEXT_PAGE = "next-page";

      // --- Document Types ---
      this.DOCTYP_APP = "DOCTYP_APP"; //Application
      this.DOCTYP_COMB_APP = "DOCTYP_COMB_APP"; //Combined Application
      this.DOCTYP_W9_FORM = "DOCTYP_W9_FORM"; //IRSW-9 Form
      this.DOCTYP_ALLCO_AGREE = "DOCTYP_ALLCO_AGREE"; //All Company Agreement
      this.DOCTYP_REP_AGREE = "DOCTYP_REP_AGREE"; //Representative Agreement
      this.DOCTYP_COMSCHED_AGREE = "DOCTYP_COMSCHED_AGREE"; //Commission Schedule Agreement
      this.DOCTYP_STATE_LIC = "DOCTYP_STATE_LIC"; //State License
      this.DOCTYP_EO_CERT = "DOCTYP_EO_CERT"; //E & O Certificate
      this.DOCTYP_DRV_LIC = "DOCTYP_DRV_LIC"; //Drivers License
      this.DOCTYP_CR_CARD_AGREE = "DOCTYP_CR_CARD_AGREE"; //Credit Card Agreement
      this.DOCTYP_ASGN_OF_COMM = "DOCTYP_ASGN_OF_COMM"; //Assignment Of Commissions
      this.DOCTYP_UNK_ADDTL_DOC = "DOCTYP_UNK_ADDTL_DOC"; //Additional Document
      this.DOCTYP_CO_POLICY = "DOCTYP_CO_POLICY"; //Company Policy
      this.DOCTYP_AML_GUIDE = "DOCTYP_AML_GUIDE"; //Anti-Money Laundering Guide

      // Types of files to download
      this.DWNLD_TYP_USER_DOC = 0;
      this.DWNLD_TYP_GENERATED = 1;

      // --- User status in SSO+App ---
      this.USERSTATUS_SSO_NOT_FOUND = "SSO_NOT_FOUND";
      this.USERSTATUS_IN_SSO_INACTIVE = "IN_SSO_INACTIVE";
      this.USERSTATUS_IN_SSO_ONLY = "IN_SSO_ONLY";
      this.USERSTATUS_SIGNED_UP = "SIGNED_UP";

      // MD Update User status
      this.MDUPDATESTATUS_NOT_IN_SAME_ORG = "NOT_IN_SAME_ORG";
      this.MDUPDATESTATUS_WRONG_MD_UPDATE_LINK = "WRONG_MD_UPDATE_LINK";
      this.MDUPDATESTATUS_UNKOWN_MD_UPDATE_ERROR = "UNKOWN_MD_UPDATE_ERROR";
      this.MDUPDATESTATUS_CANNOT_ASSIGN_MD_TWICE = "CANNOT_ASSIGN_MD_TWICE";

      //Link Validation Failure Code
      this.LINK_FAILCODE_SCHED_INACTIVE = "SCHED_INACTIVE";
      this.LINK_FAILCODE_APPT_LINK_DELETED = "APPT_LINK_DELETED";
      this.LINK_FAILCODE_APPT_LINK_INVALID = "APPT_LINK_INVALID";
      this.LINK_FAILCODE_MD_LINK_INVALID = "MD_LINK_INVALID";
      this.LINK_FAILCODE_AGENT_LINK_INVALID = "AGENT_LINK_INVALID";
      this.LINK_FAILCODE_UNKNOWN_INVALID_LINK = "UNKNOWN_INVALID_LINK";

   }
}
